var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4_comment"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448,32H64c-26.5,0-48,21.5-48,48v256c0,26.5,21.5,48,48,48h48v80c0,6.2,3.5,11.7,9.1,14.4 c2.2,1,4.6,1.6,6.9,1.6c3.6,0,7.1-1.2,10-3.5L253.6,384H448c26.5,0,48-21.5,48-48V80C496,53.5,474.5,32,448,32z M259.1,314.9 c-1,0.1-1.9,0.2-2.9,0.2c-12.8-0.1-23.1-10.5-23-23.3c0.1-11.7,8.8-21.4,20.3-22.8c12.7-1.5,24.2,7.5,25.7,20.2 C280.8,301.8,271.8,313.3,259.1,314.9z M278.2,137.2l-6.6,76.3c-0.3,7.2-1.9,14.3-4.7,20.9c-3.3,6.5-11.3,9.1-17.8,5.7 c-2.4-1.2-4.3-3.1-5.6-5.5c-2.6-6.9-4.2-14.1-4.5-21.4l-5-74.1c-1-14.9-6.1-39,5.3-51.1c8.7-9.3,29.2-10.9,35.4,2 C280.1,105.1,281.3,121.4,278.2,137.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/Feedback_Icon.fd2d5ee2.svg";
export { ForwardRef as ReactComponent };